import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";
import type { TocRegionTypeCardFragment } from "../../client/generated";

type Props = {
  fragment: TocRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function TOCRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "toc",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("TOCRegionTypeCard.title")}
      description={t("TOCRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
